module.exports = __webpack_public_path__ + "static/media/twitter.3d74e8bf.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/contact/twitter.png
// module id = 1510
// module chunks = 0